import { useEffect, useState } from "react";

const useSelectorModal = () => {
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);

  // you should always unset the item whenever the modal closes so you don't accidentally perform CRUD actions on the wrong user/SC/promo/etc
  useEffect(() => {
    if (!open) {
      setSelectedItem(null);
    }
  }, [open]);

  return {
    open,
    setOpen,
    selectedItem,
    setSelectedItem,
  };
};

export default useSelectorModal;
